/**
 * Auth API client wrapping the backend /auth/* endpoints.
 * Implements the phone-based login flow: submit a phone number, verify the
 * SMS code, choose a username for new accounts, and log out.
 * Consumed by the SignUpOrLogIn page; session state lives in cookies
 * (see lib/axios.ts) and UserContext.
 */
import { api } from "@/lib/axios";
import { PrivateUser } from "@/types/user";

export const AuthAPI = {
    submitPhone: async (phone: string) => {
        const { data } = await api.post("/auth/phone", { phone });
        return data;
    },
    submitCode: async (phone: string, code: string) => {
        const { data } = await api.post<{ user: PrivateUser | null }>("/auth/code", {
            phone,
            code,
        });
        return data;
    },
    submitUsername: async (phone: string, username: string) => {
        const { data } = await api.post<{ user: PrivateUser | null }>("/auth/username", {
            phone,
            username,
        });
        return data;
    },
    logout: async () => {
        await api.post("/auth/logout");
    },
};
